export default "__VITE_ASSET__CrTz3lWD__"